/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IUniswapExchangeFactory,
  IUniswapExchangeFactoryInterface,
} from "../IUniswapExchangeFactory";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IERC20TokenV06",
        name: "token",
        type: "address",
      },
    ],
    name: "getExchange",
    outputs: [
      {
        internalType: "contract IUniswapExchange",
        name: "exchange",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IUniswapExchangeFactory__factory {
  static readonly abi = _abi;
  static createInterface(): IUniswapExchangeFactoryInterface {
    return new utils.Interface(_abi) as IUniswapExchangeFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IUniswapExchangeFactory {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as IUniswapExchangeFactory;
  }
}
